import { INVOICE_STATES, QUERY_PARAMETERS } from "@/constants";

export function upperDateCompare(expectedDate, dateDelta) {
  let today = new Date();
  return new Date(expectedDate) > today.setDate(today.getDate() + dateDelta);
}

export function lowerDateCompare(expectedDate, dateDelta) {
  let today = new Date();
  return new Date(expectedDate) < today.setDate(today.getDate() + dateDelta);
}

function validatePageNo(pageNo, totalPages) {
  if (typeof pageNo === "number") {
    if ((pageNo > totalPages && (totalPages === 0 && pageNo !== 1)) || pageNo < 1) {
      throw new RangeError(`Invalid page number ${pageNo} of total pages ${totalPages}`);
    } else {
      return true;
    }
  } else {
    throw new TypeError(
      `Invalid page number ${pageNo} of type ${typeof pageNo}, pass either a valid type or a page number`
    );
  }
}

export function validateAdminQueryParameter(queryParameter, totalPages) {
  let params = [];
  if(Object.keys(queryParameter).length !== 1 && !(Object.hasOwn(queryParameter, QUERY_PARAMETERS.START_TIME) && Object.hasOwn(queryParameter, QUERY_PARAMETERS.END_TIME) ||
    (Object.hasOwn(queryParameter, QUERY_PARAMETERS.ISSUE_START_TIME) && Object.hasOwn(queryParameter, QUERY_PARAMETERS.ISSUE_END_TIME)))) {
    throw new Error("Only one query parameter to be passed");
  }
  if(Object.hasOwn(queryParameter, QUERY_PARAMETERS.PAGE_NO)) {
    validatePageNo(queryParameter[QUERY_PARAMETERS.PAGE_NO], totalPages);
    params.push({ label: QUERY_PARAMETERS.PAGE_NO, value: queryParameter[QUERY_PARAMETERS.PAGE_NO]});
  } else if(Object.hasOwn(queryParameter, QUERY_PARAMETERS.START_TIME) && Object.hasOwn(queryParameter, QUERY_PARAMETERS.END_TIME)) {
    params.push({ label: QUERY_PARAMETERS.START_TIME, value: queryParameter[QUERY_PARAMETERS.START_TIME] });
    params.push({ label: QUERY_PARAMETERS.END_TIME, value: queryParameter[QUERY_PARAMETERS.END_TIME] });
  } else if(Object.hasOwn(queryParameter, QUERY_PARAMETERS.ISSUE_START_TIME) && Object.hasOwn(queryParameter, QUERY_PARAMETERS.ISSUE_END_TIME)) {
    params.push({ label: QUERY_PARAMETERS.ISSUE_START_TIME, value: queryParameter[QUERY_PARAMETERS.ISSUE_START_TIME] });
    params.push({ label: QUERY_PARAMETERS.ISSUE_END_TIME, value: queryParameter[QUERY_PARAMETERS.ISSUE_END_TIME] });
  } else if(Object.hasOwn(queryParameter, QUERY_PARAMETERS.SORT)) {
    params.push({ label: QUERY_PARAMETERS.SORT, value: queryParameter[QUERY_PARAMETERS.SORT] });
  } else if(Object.hasOwn(queryParameter, QUERY_PARAMETERS.CURRENCY)) {
    params.push({ label: QUERY_PARAMETERS.CURRENCY, value: queryParameter[QUERY_PARAMETERS.CURRENCY] });
  } else if(Object.hasOwn(queryParameter, QUERY_PARAMETERS.TYPE)) {
    params.push({ label: QUERY_PARAMETERS.TYPE, value: queryParameter[QUERY_PARAMETERS.TYPE] });
  } else if(Object.hasOwn(queryParameter, QUERY_PARAMETERS.SEARCH)) {
    params.push({ label: QUERY_PARAMETERS.SEARCH, value: queryParameter[QUERY_PARAMETERS.SEARCH] });
  } else if(Object.hasOwn(queryParameter, QUERY_PARAMETERS.STATUS)) {
    if (queryParameter[QUERY_PARAMETERS.STATUS] === null) {
      params.push({ label: QUERY_PARAMETERS.STATUS, value: null});
    } else if (!Object.hasOwn(INVOICE_STATES, queryParameter[QUERY_PARAMETERS.STATUS])) {
      throw new TypeError("Not a valid Invoice State");
    } else {
      params.push({ label: QUERY_PARAMETERS.STATUS, value: queryParameter[QUERY_PARAMETERS.STATUS]});
    }
  } else if(Object.hasOwn(queryParameter, QUERY_PARAMETERS.ID)) {
    params.push({ label: QUERY_PARAMETERS.ID, value: queryParameter[QUERY_PARAMETERS.ID] });
  } else if(Object.hasOwn(queryParameter, QUERY_PARAMETERS.EMAIL_CONFIG)) {
    params.push({ label: QUERY_PARAMETERS.EMAIL_CONFIG, value: queryParameter[QUERY_PARAMETERS.EMAIL_CONFIG] });
  } else if(Object.hasOwn(queryParameter, QUERY_PARAMETERS.PERIOD)) {
    params.push({ label: QUERY_PARAMETERS.PERIOD, value: queryParameter[QUERY_PARAMETERS.PERIOD] });
  } else if(Object.hasOwn(queryParameter, QUERY_PARAMETERS.CHART)) {
    params.push({ label: QUERY_PARAMETERS.CHART, value: queryParameter[QUERY_PARAMETERS.CHART] });
  } else if(Object.hasOwn(queryParameter, QUERY_PARAMETERS.AMOUNT)) {
    params.push({ label: QUERY_PARAMETERS.AMOUNT, value: queryParameter[QUERY_PARAMETERS.AMOUNT] });
  } else if(Object.hasOwn(queryParameter, QUERY_PARAMETERS.CUMMULATIVE)) {
    params.push({ label: QUERY_PARAMETERS.CUMMULATIVE, value: queryParameter[QUERY_PARAMETERS.CUMMULATIVE] });
  } else if(Object.hasOwn(queryParameter, QUERY_PARAMETERS.PERCENT)) {
    params.push({ label: QUERY_PARAMETERS.PERCENT, value: queryParameter[QUERY_PARAMETERS.PERCENT] });
  } else {
    throw new Error("Invalid Query Parameter Type");
  }
  return params;
}
 